// Essay metadata only — deliberately free of any visualization or JSON imports so the
// landing page (and therefore the main bundle) stays light.
//
// All three essays are now scrolling pieces with their own page and their own
// per-scene data loading, so there is no longer a project loader here: the accordion
// that LOADERS used to feed has no remaining route.

// The index groups by `category` and prints the group name as a heading, so nothing
// on a card needs to repeat it — which is why the toys carry no `meta` label.
export const CATEGORIES = [
  { id: 'data-science', title: 'Data Science' },
  { id: 'just-for-fun', title: 'Just For Fun' },
];

export const ESSAYS = [
  {
    slug: 'visualizing-corpora',
    title: 'Visualizing Corpora',
    subtitle: 'Counting the words in a library, then drawing what the counts say.',
    category: 'data-science',
    accent: 'feature-card-global',
    count: 8,
    // Rendered as a scrolling essay rather than the accordion, so the card
    // advertises the format instead of a project count.
    format: 'essay',
    meta: 'Scrolling essay',
    graphic: 'circlepack',
  },
  {
    slug: 'exploring-transformers',
    title: 'Exploring Transformers',
    subtitle: 'How a machine gets from a stream of characters to a sentence.',
    category: 'data-science',
    accent: 'feature-card-ai',
    count: 11,
    format: 'essay',
    meta: 'Scrolling essay',
    graphic: 'heatmap',
  },
  {
    slug: 'international-politics-of-information',
    title: 'The Media Ecology of Online Geopolitics',
    subtitle: 'Who gets written down, who gets counted, and in whose language.',
    category: 'data-science',
    accent: 'feature-card-photo',
    count: 3,
    format: 'essay',
    meta: 'Scrolling essay',
    graphic: 'globe',
  },
  {
    // Titled for what it is, not for the section it sits in — and it matches the
    // page's own heading, which the old "Just For Fun" title did not.
    slug: 'just-for-fun',
    title: 'Node-edge Microbes',
    subtitle: 'A graph kept permanently warm, fed one node at a time.',
    category: 'just-for-fun',
    accent: 'feature-card-ai',
    count: 1,
    format: 'essay',
    graphic: 'microbe',
  },
  {
    slug: 'spirograph',
    title: 'Spirograph',
    subtitle: 'Scroll turns the gears; the gears draw.',
    category: 'just-for-fun',
    accent: 'feature-card-global',
    count: 1,
    format: 'essay',
    graphic: 'spiro',
  },
  {
    slug: 'mandala-mill',
    title: 'Mandala Mill',
    subtitle: 'Where a shape starts decides everything that follows.',
    category: 'just-for-fun',
    accent: 'feature-card-photo',
    count: 1,
    format: 'essay',
    graphic: 'mill',
  },
];

export const essaysByCategory = (id) =>
  ESSAYS.filter((essay) => essay.category === id);

export const getEssay = (slug) => ESSAYS.find((essay) => essay.slug === slug);
